export const ID_TYPE_BODEGA            = 1;
export const ID_TYPE_RESTAURANTE            = 2;
export const ID_TYPE_RESTAURANTE_SOLO_ENTREGA            = 3;
export const ID_TYPE_RESTAURANTE_DIRECTO            = 4;
